"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuexClass = require("vuex-class");

var _vuePropertyDecorator = require("vue-property-decorator");

var _elementUi = require("element-ui");

var _socket = require("socket.io-client");

var _moment = _interopRequireDefault(require("moment"));

var _loading = require("@/mixins/loading/loading");

var _milkRunV = require("@/mixins/milk-run-v2/milk-run-v2");

var _permission = require("@/mixins/permission/permission");

var _ganttFilter = _interopRequireDefault(require("@/views/milk-run-v2/components/gantt-filter/gantt-filter.vue"));

var _ganttChart = _interopRequireDefault(require("@/views/milk-run-v2/components/gantt-chart/gantt-chart.vue"));

var _countdown = _interopRequireDefault(require("@/components/countdown/countdown.vue"));

var _variables = _interopRequireDefault(require("@/styles/mixins/_variables.scss"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var MRMainDashboardComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(MRMainDashboardComponent, _Mixins);

  var _super = _createSuper(MRMainDashboardComponent);

  function MRMainDashboardComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, MRMainDashboardComponent);
    _this = _super.apply(this, arguments);
    _this.initAutoAddedDays = 0;
    _this.timeStepper = 10;
    _this.startDate = null;
    _this.endDate = null;
    _this.routeViewOptions = ['plannedRoutes', 'actualRoutes'];
    _this.planViewType = 'daily';
    _this.currentPlanId = null;
    _this.gcHeight = 400;
    _this.oldGCHeight = 400;
    _this.gcFilterHeight = 40;
    _this.refreshTime = 30; // seconds

    _this.isPlay = true;
    _this.isPause = false;
    _this.socket = null;
    _this.audioPath = require('@/assets/audio/mixkit-bell-notification-933.wav');
    _this.audio = new Audio(_this.audioPath);
    _this.truckStatusFromSocket = [];
    _this.alertType = [];
    return _this;
  }

  (0, _createClass2.default)(MRMainDashboardComponent, [{
    key: "onFSChanges",
    value: function onFSChanges(newVal) {
      if (newVal) {
        this.gcHeight = window.innerHeight - this.gcFilterHeight;
      } else {
        this.gcHeight = this.oldGCHeight - this.gcFilterHeight;
      }
    }
  }, {
    key: "containerStyles",
    get: function get() {
      return {
        height: !this.$isFullscreen ? 'calc(100vh - 60px)' : '100%'
      };
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      if (this.socket) {
        this.socket.close();
      }
    }
  }, {
    key: "created",
    value: function created() {
      if (window.innerWidth < _variables.default['md-min']) {
        this.$isMobile = true;
      }

      this.refreshTime = parseInt(this.helper.get(this.$userSetting, 'default14', 30), 10);
      this.startDate = (0, _moment.default)(new Date()).subtract(1, 'days').format('YYYY-MM-DD');
      this.endDate = (0, _moment.default)(new Date()).add(1, 'days').format('YYYY-MM-DD');
      this.$planDateRange = [this.startDate, this.endDate]; // this.startDate = '2021-06-09';
      // this.endDate = '2021-06-11';

      this.$planDateRange = [this.startDate, this.endDate];
    }
  }, {
    key: "mounted",
    value: function () {
      var _mounted = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var containerEl, countdownEl;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.$truckLoading = true;
                containerEl = this.helper.get(this.$refs, 'container', null);

                if (containerEl) {
                  this.gcHeight = containerEl.clientHeight - this.gcFilterHeight;
                  this.oldGCHeight = containerEl.clientHeight;
                }

                if (!this.$userSetting.default21) {
                  _context.next = 10;
                  break;
                }

                this.socket = (0, _socket.io)("".concat(process.env.VUE_APP_API_ROUTING_SOCKET, "/v1/milkrun"), {
                  secure: true,
                  reconnection: true,
                  rejectUnauthorized: false,
                  query: (0, _defineProperty2.default)({}, process.env.VUE_APP_CUSTOMER_KEY, this.$userInformation.customerKey),
                  extraHeaders: (0, _defineProperty2.default)({}, process.env.VUE_APP_SECRET_KEY, process.env.VUE_APP_SECRET_KEY_HASH)
                });
                _context.next = 7;
                return this.$initPlan();

              case 7:
                this.listenToSocket();
                _context.next = 15;
                break;

              case 10:
                countdownEl = this.helper.get(this.$refs, 'countdown', null);

                if (!countdownEl) {
                  _context.next = 15;
                  break;
                }

                _context.next = 14;
                return this.$initPlan();

              case 14:
                countdownEl.startTimer();

              case 15:
                // read this jnpl updating the truck statuses

                /*this.$plan.trucks.forEach(truck => {
                    const lastInTransit = this.helper.findLast(truck.routes, (r) => r.status === 'INTRANSIT');
                    const lastCompleted = this.helper.findLast(truck.routes, (r) => r.status === 'COMPLETED');
                     if (lastInTransit) {
                        this.truckStatusFromSocket.push({
                            vehicleId: truck['vehicleId'],
                            driverId: truck['driver']['id'],
                            status: lastInTransit.additionalData.startLogType,
                        });
                    } else if (lastCompleted) {
                        this.truckStatusFromSocket.push({
                            vehicleId: truck['vehicleId'],
                            driverId: truck['driver']['id'],
                            status: lastCompleted.additionalData.endLogType,
                        });
                    } else {
                        this.truckStatusFromSocket.push({
                            vehicleId: truck['vehicleId'],
                            driverId: truck['driver']['id'],
                            status: 'NORMAL',
                        });
                    }
                });*/
                this.$truckLoading = false;

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function mounted() {
        return _mounted.apply(this, arguments);
      }

      return mounted;
    }()
  }, {
    key: "handleCountdownZero",
    value: function () {
      var _handleCountdownZero = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.logger.info('Refresh from interval');
                _context2.next = 3;
                return this.$initPlan();

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleCountdownZero() {
        return _handleCountdownZero.apply(this, arguments);
      }

      return handleCountdownZero;
    }()
  }, {
    key: "handleTimeStepperChanges",
    value: function handleTimeStepperChanges(newVal) {
      this.timeStepper = newVal;
    }
  }, {
    key: "handleRouteViewsChanges",
    value: function handleRouteViewsChanges(newVal) {
      this.routeViewOptions = newVal;
    }
  }, {
    key: "handleGCPlay",
    value: function handleGCPlay() {
      this.isPlay = true;
      this.isPause = false;
    }
  }, {
    key: "handleGCPause",
    value: function handleGCPause() {
      this.isPlay = false;
      this.isPause = true;
    }
  }, {
    key: "listenToSocket",
    value: function listenToSocket() {
      var _this2 = this;

      this.socket.on('connect', /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this2.logger.info('socket-connected', _this2.socket.id);

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      })));
      this.socket.on('notification', /*#__PURE__*/function () {
        var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(res) {
          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _this2.handleNotificationSocket(res);

                case 1:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
      this.socket.on('orderupdate', /*#__PURE__*/function () {
        var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(res) {
          return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _this2.logger.info('socket-orderupdate');

                  _this2.$initPlan();

                case 2:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }));

        return function (_x2) {
          return _ref3.apply(this, arguments);
        };
      }());
      this.socket.on('error', /*#__PURE__*/function () {
        var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(res) {
          return regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  _this2.logger.info('socket-error');

                case 1:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6);
        }));

        return function (_x3) {
          return _ref4.apply(this, arguments);
        };
      }());
      this.socket.on('connect_error', /*#__PURE__*/function () {
        var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(res) {
          return regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  _this2.logger.info('socket-connect_error');

                case 1:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7);
        }));

        return function (_x4) {
          return _ref5.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "handleNotificationSocket",
    value: function handleNotificationSocket(res) {
      this.logger.info('socket-notification');

      if (res.data && res.status === 'success') {
        var logType = res.data.logType;
        var notifType = res.data.data.notificationType;
        var driverName = this.helper.get(res, 'data.data.driverName', '-');
        var plateNumber = this.helper.get(res, 'data.data.plateNumber', '-');
        var projectCode = this.helper.uniq(this.helper.get(res, 'data.data.projectCode', [])).join(', ');
        var companyName = this.helper.uniq(this.helper.get(res, 'data.data.companyName', [])).join(', ');
        var shipmentReference = this.helper.uniq(this.helper.get(res, 'data.data.shipmentReference', [])).join(', ');
        var msgTitle = "".concat(driverName, " ").concat(plateNumber, " ").concat(projectCode, " ").concat(companyName, " ").concat(shipmentReference, " ").concat(notifType === 'START' ? this.$t('notification.arrived') : notifType, "\n\t\t\t");
        var message = {
          title: msgTitle,
          duration: 30000
        };

        switch (logType) {
          case 'NORMAL':
            _elementUi.Notification.success(message);

            break;

          case 'YELLOW':
            _elementUi.Notification.warning(message);

            break;

          case 'RED':
            _elementUi.Notification.error(message);

            break;
        }

        this.audio.play();
        this.$initPlan();
      }
    }
  }, {
    key: "handleAlertChange",
    value: function handleAlertChange(newVal) {
      this.alertType = newVal;
    }
  }, {
    key: "handleSort",
    value: function () {
      var _handleSort = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(_ref6) {
        var isSortAsc, colName;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                isSortAsc = _ref6.isSortAsc, colName = _ref6.colName;
                _context8.next = 3;
                return this.$initPlan({
                  isSortAsc: isSortAsc,
                  colName: colName
                });

              case 3:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function handleSort(_x5) {
        return _handleSort.apply(this, arguments);
      }

      return handleSort;
    }()
  }]);
  return MRMainDashboardComponent;
}((0, _vuePropertyDecorator.Mixins)(_permission.PermissionMixin, _loading.LoadingMixin, _milkRunV.MilkRunV2Mixin));

(0, _tslib.__decorate)([(0, _vuexClass.Getter)('isFullscreen', {
  namespace: 'common'
})], MRMainDashboardComponent.prototype, "$isFullscreen", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('$isFullscreen')], MRMainDashboardComponent.prototype, "onFSChanges", null);
MRMainDashboardComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'MRMainDashboardComponent',
  components: {
    'gantt-filter': _ganttFilter.default,
    'gantt-chart': _ganttChart.default,
    countdown: _countdown.default,
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col
  }
})], MRMainDashboardComponent);
var _default = MRMainDashboardComponent;
exports.default = _default;